export const CITIES_DATA = [
  {
    label: "Bangalore",
    value : "Bangalore",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/bangalore-symbol.svg",
     
  },
  {
    label: "Delhi",
    value : "Delhi",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/delhi-symbol.svg",

  },
  {
    label: "Pune",
    value : "Pune",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/pune-symbol.svg",
  },
  {
    label: "Hyderabad",
    value : "Hyderabad",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/hyderabad-symbol.svg",
  },
  {
    label: "Lucknow",
    value : "Lucknow",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/lucknow-symbol.svg",
  },
  // {
  //   label: "Thane",
  //   value : "Thane",
  //   icons:
  //     "https://assets.turnoclub.com/developer/innovolt/icons/thane-symbol.svg",
  // },
  {
    label: "Kanpur",
    value : "Kanpur",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/kanpur-symbol.svg",
  },
  {
    label:"Chennai",
    value : "Chennai",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/chennai-symbol.svg",
  },
  {
    label:"Others",
    value : "Others",
    icons:
      "https://assets.turnoclub.com/developer/innovolt/icons/other-symbol.svg",

  }
];
